import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5" }
const _hoisted_2 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5" }
const _hoisted_3 = { class: "flex items-start gap-3" }
const _hoisted_4 = { class: "min-w-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }, " Nome registrado no CRM ", -1)
const _hoisted_6 = {
  "data-testid": "doctor-crm-name",
  class: "text-base text-gray-900 break-words"
}
const _hoisted_7 = { class: "flex items-start gap-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }, "Número do CRM", -1)
const _hoisted_9 = {
  "data-testid": "doctor-crm-number",
  class: "text-base text-gray-900"
}
const _hoisted_10 = {
  key: 0,
  class: "flex items-start gap-3"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }, "Status do CRM", -1)
const _hoisted_12 = { class: "text-base text-gray-900" }
const _hoisted_13 = {
  key: 1,
  class: "flex items-start gap-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500" }, "Tipo do CRM", -1)
const _hoisted_15 = { class: "text-base text-gray-900" }
const _hoisted_16 = {
  key: 0,
  class: "pt-5 border-t border-gray-100"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 mb-3" }, "CRMs do médico", -1)
const _hoisted_18 = { class: "flex flex-col gap-2" }
const _hoisted_19 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_20 = {
  key: 0,
  "data-testid": "doctor-crm-main-badge",
  class: "inline-flex items-center rounded-full bg-primary5 border border-primary px-2 py-0.5 text-xs font-medium text-primary"
}
const _hoisted_21 = {
  key: 1,
  class: "text-xs text-gray-500 ml-auto"
}
const _hoisted_22 = {
  key: 1,
  class: "pt-5 border-t border-gray-100"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium uppercase tracking-wide text-gray-500 mb-3" }, "Especialidades", -1)
const _hoisted_24 = { class: "flex flex-wrap gap-2" }
const _hoisted_25 = { class: "text-sm font-medium text-textPrimary" }
const _hoisted_26 = {
  key: 0,
  class: "text-xs text-primary/80 border-l border-primary/30 pl-2"
}

import { computed } from 'vue'
import {
  mdiAccountOutline,
  mdiCardAccountDetailsOutline,
  mdiCheckDecagramOutline,
  mdiBadgeAccountOutline,
  mdiStethoscope
} from '@mdi/js'

import type { DoctorDetailResponse } from '@/Network/Types/Responses/CompanyResponses'
import type { DoctorCrmResponse } from '@/Network/Types/Responses/DoctorCrmResponses'
import DetailCard from '../atoms/DetailCard.vue'
import { toTitleCase } from '../../helpers/doctorStatus'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfessionalDataPanel',
  props: {
    doctor: {},
    crms: { default: () => [] }
  },
  emits: ["transferCrm"],
  setup(__props: any, { emit }) {

const props = __props;





const crmName = computed(() => toTitleCase(props.doctor.doctor.mainCrm.name))

const hasMultipleCrms = computed(() => props.crms.length > 1)

const hasSpecialties = computed(
  () =>
    props.doctor.doctor.mainCrm.doctorSpecialties &&
    props.doctor.doctor.mainCrm.doctorSpecialties.length > 0
)

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DetailCard, { title: "Dados Profissionais" }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        "data-testid": "transfer-crm-button",
        class: "text-primary hover:underline text-sm font-medium whitespace-nowrap",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('transferCrm')))
      }, " Adicionar/Transferir CRM ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "grey-darken-1",
              class: "mt-0.5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(mdiAccountOutline)), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, _toDisplayString(crmName.value || '—'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_icon, {
              size: "20",
              color: "grey-darken-1",
              class: "mt-0.5"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(mdiCardAccountDetailsOutline)), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.doctor.doctor.mainCrm.number) + "-" + _toDisplayString(_ctx.doctor.doctor.mainCrm.uf), 1)
            ])
          ]),
          (_ctx.doctor.doctor.mainCrm.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_v_icon, {
                  size: "20",
                  color: "grey-darken-1",
                  class: "mt-0.5"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(mdiCheckDecagramOutline)), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, [
                  _hoisted_11,
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.doctor.doctor.mainCrm.status), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.doctor.doctor.mainCrm.type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_v_icon, {
                  size: "20",
                  color: "grey-darken-1",
                  class: "mt-0.5"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(mdiBadgeAccountOutline)), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, [
                  _hoisted_14,
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.doctor.doctor.mainCrm.type), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (hasMultipleCrms.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crms, (crm) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: crm.id,
                    "data-testid": "doctor-crm-item",
                    class: "flex flex-wrap items-center gap-2 rounded-lg border border-gray-200 px-3 py-2"
                  }, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(crm.number) + "-" + _toDisplayString(crm.uf), 1),
                    (crm.isMain)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Principal "))
                      : _createCommentVNode("", true),
                    (crm.status)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(crm.status), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (hasSpecialties.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctor.doctor.mainCrm.doctorSpecialties, (doctorSpecialty) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: doctorSpecialty.id,
                    class: "inline-flex items-center gap-2 rounded-lg border border-primary bg-primary5 px-3 py-1.5"
                  }, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(mdiStethoscope)), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(doctorSpecialty.specialty.name), 1),
                    (doctorSpecialty.rqe)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, " RQE " + _toDisplayString(doctorSpecialty.rqe), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})